import { useEffect } from 'react';
import { dispatcher } from 'dispatcher';

export const useLegacyBonusDetailsPopupCloseListener = (listener) => {
    useEffect(() => {
        dispatcher.listen('bonusmultiview:bonus-details:popup:close', listener);

        return () => {
            dispatcher.removeListener('bonusmultiview:bonus-details:popup:close', listener);
        };
    }, [listener]);
};
